//  Libraries
import React from 'react';
import PropTypes from 'prop-types';
import config from 'config';
import { Button, Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import * as sessionStorageHelper from 'app-lib/helpers/SessionStorageHelper';
import * as mixpanelTracker from 'app-lib/mixpanel/mixpanelTracker';

export class WebinarRedirectModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: true
        };
    }

    componentDidMount() {
        sessionStorageHelper.setSessionStorageKey('webinarRedirectModalShown', true);
    }

    close() {
        mixpanelTracker.track(`${mixpanelTracker.webinarRedirectModalClosed}`);
        this.setState({ showModal: false });
    }

    getWebinarRedirectContent() {
        const {t} = this.props;
        return (
            <div className="webinar-redirect-modal-content">
                <h1>{t('webinarRedirectModal.header')}</h1>
                <div>{t('webinarRedirectModal.bodyText')}</div>
                <Button className="gotit-btn" onClick={this.close.bind(this)}>
                    <div className="gotit-btn-text">{t('webinarRedirectModal.button')}</div>
                </Button>
            </div>
        );
    }

    render() {
        const style = {
            backgroundImage: `url(${config.assets.url}/images/shared-components/modal/webinar-redirect-background.svg)`
        };
        return (
            <Modal dialogClassName="webinar-redirect-modal-dialog" show={this.state.showModal} onHide={this.close.bind(this)}>
                <Modal.Body style={style}>
                    <i className="togo-icon togo-icon-closes pointer webinar-redirect-modal-close-btn" onClick={this.close.bind(this)} aria-hidden="true"></i>
                    {this.getWebinarRedirectContent()}
                </Modal.Body>
            </Modal>
        );
    }
}

WebinarRedirectModal.propTypes = {
    onExited: PropTypes.func,
    t: PropTypes.func
};

export default translate(['translation'])(WebinarRedirectModal);



// WEBPACK FOOTER //
// ./src/components/SharedComponents/modal/webinar-redirect-modal.js